import React from "react";
import styled from "styled-components";

const I = styled.i`
  font-size: ${({size}) => `${size}px` };
  color: ${({color}) => `${color}`};
  margin: ${({margin}) => `${margin}`};
  padding: ${({padding}) => `${padding}`};
  ${({background}) => background && `background: ${background}`};
  ${({border}) => border && `border: ${border}`};
`;

const IconFA = ({ code="fas fa-shapes", size=18, color="black", background=null, margin="0", padding="0", border=null,
                  style=null, ...props }) => (
    <I className={code} size={size} color={color} background={background} margin={margin} padding={padding}
       border={border} style={style} {...props} />
);

export default IconFA;
